import { CurrencyConversionModal as Component } from './components';
import Connector from './connector';
import { ConnectorProps } from './CurrencyConversionModal.proptype';

export const CurrencyConversionModal = (props: CurrencyConversionModalProps) => (
  <Connector {...props} component={Component} />
);

export interface CurrencyConversionModalProps extends Omit<ConnectorProps, 'component'> {}
